import { User } from '@utilities/types';
import React from 'react';

interface CollaboratorCardProps {
    collaborator: User;
    renderBadge: (collaborator: User) => React.ReactNode;
    renderDropdownMenu: (collaborator: User) => React.ReactNode;
    formatDate: (date: string) => string;
}

export const CollaboratorCard: React.FC<CollaboratorCardProps> = ({ collaborator, renderBadge, renderDropdownMenu, formatDate }) => (
    <div key={collaborator._id} className="card bg-base-100 shadow-lg p-4">
        <div className="flex justify-between items-start">
            <div>
                <h3 className="font-medium">{collaborator.firstname} {collaborator.lastname}</h3>
                <p className="text-sm opacity-70">{collaborator.email}</p>
            </div>
            {renderDropdownMenu(collaborator)}
        </div>
        <div className="text-sm mt-2">
            <div className="flex items-center gap-2">
                <span>Rôle:</span>
                <span className="font-medium">{renderBadge(collaborator)}</span>
            </div>
            <p>Créé le: {collaborator.createAt ? formatDate(new Date(collaborator.createAt).toISOString()) : 'Date inconnue'}</p>
        </div>
    </div>
);

